"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedpackData = void 0;
const lodash_1 = require("lodash");
const vue_demi_1 = require("vue-demi");
const create_1 = require("../components/Modal/create");
const link_1 = require("../utils/link");
const url_1 = require("../utils/url");
const type_1 = require("./type");
const { request } = require('@futuweb/fego-render').common;
const commonApi = request.bindCommonApi('common-redpacket');
// 创建uuid
const cacheKey = 'common-redpacket-data:e668258b-7ac0-4a97-9763-564e82c561c4';
/**
 * 获取红包状态
 * @param actSign 活动标识
 * @returns 红包状态
 */
async function getRedpackStatus(actSign) {
    const res = await commonApi.get('get-redpacket-status', Object.assign({ actSign }, (0, url_1.getInviteAndGlobalContentFromUrl)()));
    return res;
}
/**
 * 发送红包
 * @param actSign 活动标识
 * @returns 发送红包结果
 */
async function sendRedpack(actSign) {
    const res = await commonApi.post('send-redpacket', Object.assign({ actSign }, (0, url_1.getInviteAndGlobalContentFromUrl)()));
    return res;
}
function useRedpackData(actSign) {
    const state = (0, vue_demi_1.reactive)({
        data: null,
        /**
         * 强制红包页面
         */
        forceRedpacketPage: false
    });
    function setForceRedpacketPage() {
        if (!state.data) {
            return;
        }
        if (!state.data.record) {
            return;
        }
        state.forceRedpacketPage = true;
    }
    async function refresh() {
        const res = await getRedpackStatus(actSign);
        state.data = res;
        // 0. 有重定向URL
        if (res.redirectUrl) {
            // 重定向到活动页面
            (0, link_1.toLink)(res.redirectUrl, {
                useCurrentWindow: true
            });
            return;
        }
        // 1. 活动已经结束
        if (!res.isActive) {
            // 活动已经结束
            console.log('活动已经结束');
            return;
        }
        // 2. 判断是否非目标人群
        if (res.uid && !res.matchRule) {
            // 非目标人群
            (0, create_1.quickCreateModal)(async () => Promise.resolve().then(() => __importStar(require('../components/NoCrowdModal/index.vue'))), {});
            console.log('非目标人群');
            return;
        }
    }
    const methods = {
        doSendRedpack: async () => {
            await sendRedpack(actSign);
        },
        setForceRedpacketPage,
        sendRedpack: (0, lodash_1.throttle)(async (isForce = false) => {
            var _a;
            try {
                if (isForce && state.forceRedpacketPage) {
                    state.forceRedpacketPage = false;
                    return {
                        showAnimate: false
                    };
                }
                if (!((_a = state.data) === null || _a === void 0 ? void 0 : _a.uid)) {
                    (0, link_1.toLogin)();
                    return {
                        showAnimate: false
                    };
                }
                if (!state.data.isActive) {
                    return {
                        showAnimate: false
                    };
                }
                if (state.data.redirectUrl) {
                    return {
                        showAnimate: false
                    };
                }
                const { matchRule } = state.data;
                if (!matchRule) {
                    return {
                        showAnimate: false
                    };
                }
                if (state.data.record && !state.forceRedpacketPage) {
                    return {
                        showAnimate: false
                    };
                }
                const sendControll = type_1.CommonRedpacketSendControllByMap[matchRule.type];
                await sendControll(methods, isForce);
                await refresh();
                return {
                    showAnimate: true
                };
            }
            catch (error) {
                console.error(error);
            }
            // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        }, 1000),
        $callOtherComponentSendPrize: (0, vue_demi_1.ref)(null)
    };
    (0, vue_demi_1.onMounted)(() => {
        refresh();
    });
    return {
        state,
        methods
    };
}
const useRedpackDataWithCahce = function (actSign) {
    const key = `${cacheKey}:${actSign}`;
    if (window[key]) {
        return window[key];
    }
    const { state, methods } = useRedpackData(actSign);
    window[key] = {
        state,
        methods
    };
    return {
        state,
        methods
    };
};
exports.useRedpackData = useRedpackDataWithCahce;
//# sourceMappingURL=data:application/json;base64,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